/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  contextualFooter module whitelist
 */

import * as constants from '../constants'

export default Object.values(constants)
